<div class="zn-step-content-sections">
  <div [class]="propertySectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Property.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Property.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator">
    </div>
      <div class="zn-step-content-section-body">
          <div class="zn-step-content-section-layout">
              <div class="zn-step-content-section-filters">
                  <div class="form-control-container">
                      <label class="form-label" for="">
                          {{ 'Planning::Entity.Property' | abpLocalization }}
                          <span class="form-label-required">*</span>
                      </label>
                      <zn-single-select
                          #propertySelect
                          [options]="propertyOptions()"
                          [optionsLoader]="loadProperties"
                          [showSearch]="true"
                          [localizationResource]="localizationResource"
                          [openUp]="false"
                          (selectedChange)="onPropertyChange($event)">
                      </zn-single-select>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div [class]="registerSectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Register.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Register.Description') | abpLocalization }}</p>
        </div>
          <div class="zn-step-content-section-actions">
              <zn-button
                type="primary"
                size="normal"
                iconLeft="bi bi-arrow-clockwise"
                [label]="(localizationKeyPrefix + '.Register.Reload') | abpLocalization"
                (clicked)="reloadRegisters()"
              ></zn-button>
          </div>
      </div>
      <hr class="zn-separator">
    </div>
      <div class="zn-step-content-section-body">
        <div class="zn-table" [class.zn-table--empty]="rows().length === 0">
          <div class="zn-table-scroll">
            <table class="zn-table-element">
              <thead>
                <tr>
                  <th>{{ columnHeaderKeys.name | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.department | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.judicialSection | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.documentaryArea | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.coneatIndex | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.deedValue | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.fiscalValue | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.previousName | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.description | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.propertyType | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.foManagement | abpLocalization }}</th>
                  <th>{{ columnHeaderKeys.lastManagementStart | abpLocalization }}</th>
                </tr>
              </thead>
              <tbody>
                @if (rows().length === 0) {
                  <tr>
                    <td class="zn-table-empty" colspan="12">
                      {{ 'LanguageService::EmptySearchResultTitle' | abpLocalization }}
                    </td>
                  </tr>
                }
                @for (row of rows(); track row.id) {
                  <tr>
                    <td>{{ row.name }}</td>
                    <td>{{ row.department }}</td>
                    <td>{{ row.judicialSection }}</td>
                    <td>{{ row.documentaryArea }}</td>
                    <td>{{ row.coneatIndex }}</td>
                    <td>{{ row.deedValue }}</td>
                    <td>{{ row.fiscalValue }}</td>
                    <td>{{ row.previousName }}</td>
                    <td>{{ row.description }}</td>
                    <td>{{ row.propertyType }}</td>
                    <td>{{ row.foManagement }}</td>
                    <td>{{ row.lastManagementStart }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</div>
